import React, { useState } from 'react';
import './App.css';

const faqData = [
    {
        question: "බෝග වගාව පිළිබඳ තාක්ෂණික ගැටළු?",
        answer: [
            "* ඔබ ප්‍රදේශයේ ගොවිජන සේවා මධ්‍යස්ථානයේ කෘෂිකර්ම උපදේශක හමුවන්න.",
            "* නැතිනම් පළාත් කෘෂිකර්ම දෙපාර්තමේන්තුවේ ක්ෂණික දුරකථන අංකය වන 070-6100404 ට අමතා සහය ලබා ගන්න."
        ]
    },
    {
        question: "කෘෂිකාර්මික පුහුණු ලබාගන්නේ කෙසේද?",
        answer: ["* ඔබ ප්‍රදේශයේ ගොවිජන සේවා මධ්‍යස්ථානයේ කෘෂිකර්ම උපදේශක හමුවන්න නැතිනම් පහත සදහන් පුහුනු ආයතන සම්බන්ධ කරගන්න",
            "දිස්ත්‍රික් කෘෂිකර්ම පුහුණු මධ්‍යස්ථානය -  කරපිංච , කුරුවිට  045 - 2264545",
            "දිස්ත්‍රික් කෘෂිකර්ම පුහුණු මධ්‍යස්ථානය - වාගොල්ල , රඹුක්කන 035 - 2265269",
            "සේවා සංස්කරණ අභ්‍යාස ආයතනය - ගොඩකුඹුර රජවක . බලන්ගොඩ  077 – 8002913",
            "* නැතිනම් පළාත් කෘෂිකර්ම දෙපාර්තමේන්තුවේ ක්ෂණික දුරකථන අංකය වන 070-6100404 ට අමතා සහය ලබා ගන්න."
        ]
    },
    {
        question: "බිම්මල් වගාව හා මී මැසි පාලනය පිළිබද තාක්ෂණික ගැටළු ?",
        answer: ["* ඔබ ප්‍රදේශයේ ගොවිජන සේවා මධ්‍යස්ථානයේ කෘෂිකර්ම උපදේශක හමුවන්න",
            "* නැතිනම් පළාත් කෘෂිකර්ම දෙපාර්තමේන්තුවේ ක්ෂණික දුරකථන අංකය වන 070-6100404 ට අමතා සහය ලබා ගන්න"]
    },
    {
        question: "ගොඩ ඉඩම් හා මඩ ඉඩම් පිලිබද ගැටළු ?",
        answer: ["* ඔබ ප්‍රදේශයේ ගොවිජන සේවා මධ්‍යස්ථානයේ ගොවිජන සංවර්ධන නිලධාරි  හමුවන්න."]
    },
    {
        question: "වගාවට අවශ්‍ය පොහොර පිළිබද ගැටළු?",
        answer: ["* තාක්ෂණ ගැටළු සදහා ඔබ ප්‍රදේශයේ ගොවිජන සේවා මධ්‍යස්ථානයේ කෘෂිකර්ම උපදේශක හමුවන්න",
            "* සේවා පිළිබද ගැටළු සදහා ඔබ ප්‍රදේශයේ ගොවිජන සේවා මධ්‍යස්ථානයේ ගොවිජන සංවර්ධන  නිලධාරි  හමුවන්න"]
    },
    {
        question: "පලතුරු පැල මිලදි ගත හැකි ස්ථාන ?",
        answer: ["දිස්ත්‍රික් කෘෂිකර්ම පුහුණු මධ්‍යස්ථානය -  කරපිංච , කුරුවිට  045 - 2264545",
            "දිස්ත්‍රික් කෘෂිකර්ම පුහුණු මධ්‍යස්ථානය - වාගොල්ල , රඹුක්කන 035 - 2265269",
            "සේවා සංස්කරණ අභ්‍යාස ආයතනය - ගොඩකුඹුර රජවක . බලන්ගොඩ  077 – 8002913",
            "මධ්‍යම පැල තවාන - බැමිණිවත්ත , මාවනැල්ල 035- 2246776 "]
    }
];

export default function FAQ({ onBackClick }) {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <main className="page-content faq-page-content">
         <button
                className="back-button"
                onClick={() => onBackClick && onBackClick('home')}
                style={{
                    backgroundColor: '#0b6b2f',
                    color: 'white',
                    border: 'none',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '14px',
                    marginBottom: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                }}
            >
                ← ආපසු
            </button>
            <h1 className="faq-title">නිතර අසන ප්‍රශ්න (FAQ)</h1>
            <hr className="footer-sep" style={{ marginBottom: '30px' }} />
            <div className="faq-container">
                {faqData.map((item, index) => (
                    <div key={index} className="faq-item-container">
                        <button
                            onClick={() => toggleFAQ(index)}
                            className="faq-question-button"
                        >
                            {item.question}
                            <span className="faq-toggle-icon">
                                {activeIndex === index ? '−' : '+'}
                            </span>
                        </button>
                        {activeIndex === index && (
                            <div className="faq-answer-content">
                                {Array.isArray(item.answer) ? (
                                    item.answer.map((line, i) => (
                                        <div key={i} className="faq-answer-line">{line}</div>
                                    ))
                                ) : (
                                    item.answer
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </main>
    );
}
